<div class="modal-backdrop" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="modal-header">
            <div class="header-info">
                <div class="text-info">
                    <!-- Step 0: Details View -->
                    <div *ngIf="step === 0" class="brand-type-badge">{{ brand.Brandtype }}</div>
                    <h2 *ngIf="step === 0">{{ brand.BrandName }}</h2>

                    <!-- Step 1: Purchase Form -->
                    <h2 *ngIf="step === 1">Purchase Voucher</h2>
                    <p class="brand-name" *ngIf="step === 1">{{ brand.BrandName }}</p>

                    <!-- Step 2: Success -->
                    <h2 *ngIf="step === 2">Purchase Successful!</h2>
                    <p class="brand-name" *ngIf="step === 2">{{ productName || brand.BrandName }}</p>
                </div>
                <div class="brand-logo-container" *ngIf="brand.BrandImage && step !== 0">
                    <img [src]="brand.BrandImage" [alt]="brand.BrandName" class="brand-logo">
                </div>
            </div>
            <button class="close-btn" (click)="closeModal()">
                <img src="assets/images/close.svg" alt="Close">
            </button>
        </div>

        <!-- Step 0: Details View -->
        <div *ngIf="step === 0" class="modal-body details-view animate-fade-in">
            <!-- Description Section -->
            <div class="details-section">
                <h3 class="section-title">Description</h3>
                <p class="description-text">{{ brand.Descriptions || 'No description available.' }}</p>
            </div>

            <!-- Terms & Conditions (Collapsible) -->
            <div class="collapsible-section" *ngIf="brand.tnc">
                <div class="section-header" (click)="toggleTerms()">
                    <h3 class="section-title">Terms & Conditions</h3>
                    <svg class="chevron-icon" [class.rotated]="showTerms" width="16" height="16" viewBox="0 0 16 16"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                    </svg>
                </div>
                <div class="section-content" *ngIf="showTerms">
                    <p class="section-text" [innerHTML]="brand.tnc"></p>
                </div>
            </div>

            <!-- How to Redeem (Collapsible) -->
            <div class="collapsible-section" *ngIf="redeemStepsArray.length > 0">
                <div class="section-header" (click)="toggleRedeemSteps()">
                    <h3 class="section-title">How to Redeem</h3>
                    <svg class="chevron-icon" [class.rotated]="showRedeemSteps" width="16" height="16"
                        viewBox="0 0 16 16" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                    </svg>
                </div>
                <div class="section-content" *ngIf="showRedeemSteps">
                    <div class="redeem-steps">
                        <div *ngFor="let step of redeemStepsArray; let i = index" class="redeem-step">
                            <div class="step-number">{{ i + 1 }}</div>
                            <div class="step-content">
                                <p class="step-text">{{ step.text }}</p>
                                <img *ngIf="step.image" [src]="step.image" [alt]="'Step ' + (i + 1)" class="step-image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Step 1: Purchase Form -->
        <div *ngIf="step === 1" class="modal-body animate-fade-in">
            <form [formGroup]="purchaseForm">
                <div class="form-group">
                    <label>Select Denomination (₹)</label>
                    <div class="custom-select-wrapper">
                        <select formControlName="denomination" class="form-select">
                            <option value="" disabled>Select Amount</option>
                            <option *ngFor="let denom of denominations" [value]="denom">{{ denom }}</option>
                        </select>
                    </div>
                    <div *ngIf="purchaseForm.get('denomination')?.invalid && purchaseForm.get('denomination')?.touched"
                        class="error-msg">
                        Please select a denomination.
                    </div>
                </div>

                <div class="form-group">
                    <label>Quantity</label>
                    <div class="input-with-spinner">
                        <input type="number" formControlName="quantity" min="1" [max]="availableStock"
                            class="form-control" [class.is-loading]="isCheckingStock">
                        <span *ngIf="isCheckingStock" class="spinner-border spinner-border-sm stock-spinner"></span>
                    </div>

                    <div class="stock-info" *ngIf="availableStock > 0 && !isCheckingStock">
                        Available Stock: {{ availableStock }}
                    </div>
                    <div class="stock-info text-danger" *ngIf="stockError">
                        {{ stockError }}
                    </div>

                    <div *ngIf="purchaseForm.get('quantity')?.invalid && purchaseForm.get('quantity')?.touched && !stockError"
                        class="error-msg">
                        Please enter a valid quantity (Max {{ availableStock }}).
                    </div>
                </div>

                <!-- Summary -->
                <div class="summary-card" *ngIf="totalCost > 0">
                    <div class="summary-row">
                        <span>Total Cost</span>
                        <span class="total-amount">₹{{ totalCost | number:'1.2-2' }}</span>
                    </div>
                </div>

                <!-- Error Message -->
                <div *ngIf="errorMessage" class="alert alert-danger mt-3">
                    {{ errorMessage }}
                </div>
            </form>
        </div>

        <!-- Step 2: Success / Voucher Display -->
        <div *ngIf="step === 2" class="modal-body animate-fade-in">
            <div class="success-message">
                <i class="bi bi-check-circle-fill text-success"></i>
                <span>{{ successMessage }}</span>
            </div>

            <div class="vouchers-list">
                <div *ngFor="let voucher of purchasedVouchers; let i = index" class="voucher-card">
                    <div class="voucher-header">
                        <span class="voucher-label">Voucher #{{ i + 1 }}</span>
                        <span class="voucher-value">₹{{ voucher.Value }}</span>
                    </div>

                    <div class="voucher-details">
                        <div class="detail-row">
                            <span class="label">Code:</span>
                            <div class="value-container">
                                <span class="code">{{ voucher.VoucherNo }}</span>
                                <button class="copy-btn" (click)="copyToClipboard(voucher.VoucherNo)" title="Copy Code">
                                    <i class="bi bi-files"></i>
                                </button>
                            </div>
                        </div>

                        <div class="detail-row" *ngIf="voucher.Voucherpin">
                            <span class="label">PIN:</span>
                            <div class="value-container">
                                <span class="code">{{ voucher.Voucherpin }}</span>
                                <button class="copy-btn" (click)="copyToClipboard(voucher.Voucherpin)" title="Copy PIN">
                                    <i class="bi bi-files"></i>
                                </button>
                            </div>
                        </div>

                        <div class="detail-row">
                            <span class="label">Expiry:</span>
                            <span class="value">{{ voucher.EndDate }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-info">
                <small>Order ID: {{ externalOrderId }}</small>
            </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <!-- Step 0: Details View -->
            <ng-container *ngIf="step === 0 && hasRedemptionUrl()">
                <button class="btn-primary w-100" (click)="proceedToPurchase()">Redeem Now</button>
            </ng-container>

            <!-- Step 1: Purchase Form -->
            <ng-container *ngIf="step === 1">
                <button class="btn-outline" (click)="closeModal()" [disabled]="isLoading">Cancel</button>
                <button class="btn-primary" (click)="submit()" [disabled]="isLoading || purchaseForm.invalid">
                    <span *ngIf="!isLoading">Buy Now</span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
                </button>
            </ng-container>

            <!-- Step 2: Success -->
            <ng-container *ngIf="step === 2">
                <button class="btn-primary w-100" (click)="closeModal()">Done</button>
            </ng-container>
        </div>
    </div>
</div>